import React from "react";
import { Field } from "react-final-form";
import {
  composeFormValidators,
  isRequired,
  isNumber,
  isNumberAndSpaces,
  isAlphaNumeric,
  isPhoneNumber,
  isEmail,
} from "@lib/validations";

import InputText from "@components/Form/InputText";

const validationsMap = {
  required: isRequired,
  vnumberSpace: isNumberAndSpaces,
  vnumber: isNumber,
  valphanumeric: isAlphaNumeric,
  vemail: isEmail,
  vname: isAlphaNumeric,
  vphone: isPhoneNumber,
};

const TextInput = (props) => {
  // if (props.valid) {
  return (
    <Field
      id={props.name}
      name={props.name}
      label={props.label}
      component={InputText}
      type="text"
      required={props.required}
      validate={composeFormValidators(
        props.required
          ? validationsMap["required"]()
          : () => {
              return undefined;
            },
        props.validation
          ? validationsMap[props.validationRules]()
          : () => {
              return undefined;
            }
      )}
    />
  );
  // }

  // Invalid component
  // return null;
};

export default TextInput;
